import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import loadable from '@loadable/component';

import { propTypes } from '../../util/types';
import { TX_TRANSITION_ACTOR_CUSTOMER } from '../../transactions/transaction';

import { sendVerificationEmail, hasCurrentUserErrors } from '../../ducks/user.duck';
import { logout, authenticationInProgress, login, signup } from '../../ducks/auth.duck';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getStateData } from '../InboxPage/InboxPage.stateData';

const Topbar = loadable(() => import(/* webpackChunkName: "Topbar" */ './Topbar/Topbar'));

/**
 * Topbar container component, which is connected to Redux Store.
 * @component
 * @param {Object} props
 * @returns {JSX.Element}
 */
export const TopbarContainerComponent = props => {
  const { notificationCount = 0, ...rest } = props;

  return <Topbar notificationCount={notificationCount} {...rest} />;
};

const mapStateToProps = state => {
  // Topbar needs isAuthenticated and isLoggedInAs
  const { isAuthenticated, isLoggedInAs, logoutError, authScopes, loginError, signupError, } = state.auth;
  // Topbar needs user info.
  const {
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    currentUserNotificationCount: providerNotificationCount,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
  } = state.user;
  
  // ✅ Calculate customer notification count from InboxPage state
  const { transactionRefs = [] } = state.InboxPage || {};
  const transactions = getMarketplaceEntities(state, transactionRefs);
  
  const customerNotificationCount = transactions.filter(tx => {
    try {
      const transactionRole = TX_TRANSITION_ACTOR_CUSTOMER;
      const minimalIntl = {
        formatMessage: ({ id }, values) => id,
      };
      const stateData = getStateData({ transaction: tx, transactionRole, intl: minimalIntl });
      // Count transactions where customer needs to take action
      return stateData?.actionNeeded === true;
    } catch (e) {
      return false;
    }
  }).length;
  
  // ✅ Total notification count = provider notifications + customer notifications
  const notificationCount = (providerNotificationCount || 0) + customerNotificationCount;
  
  console.log('🔔 Topbar - Provider notifications:', providerNotificationCount);
  console.log('🔔 Topbar - Customer notifications:', customerNotificationCount);
  console.log('🔔 Topbar - Total notifications:', notificationCount);
  
  const hasGenericError = !!(logoutError || hasCurrentUserErrors(state));
  return {
    authInProgress: authenticationInProgress(state),
    loginError,
    signupError,
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    notificationCount,
    isAuthenticated,
    isLoggedInAs,
    authScopes,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    hasGenericError,
  };
};

const mapDispatchToProps = dispatch => ({
  onLogout: historyPush => dispatch(logout(historyPush)),
  onLogin: ({ email, password }) => dispatch(login(email, password)),
  onSignup: params => dispatch(signup(params)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const TopbarContainer = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(TopbarContainerComponent);

export default TopbarContainer;